(function () {
  'use strict';

  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.getElementById('MobileMenu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.body.classList.remove('menu-open');
      }
    });
  }

  document.querySelectorAll('[data-product-thumbnail]').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      var mainImage = document.querySelector('[data-product-main-image]');
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.full;
      document.querySelectorAll('[data-product-thumbnail]').forEach(function (item) {
        item.classList.remove('is-active');
      });
      thumbnail.classList.add('is-active');
    });
  });

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header = document.querySelector('.site-header');
  var hero = document.querySelector('[data-motion-hero]');
  var stories = Array.prototype.slice.call(document.querySelectorAll('[data-cinematic-story]'));
  var ticking = false;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function setStoryScene(story, activeIndex, progress) {
    var media = story.querySelectorAll('[data-story-media]');
    var copies = story.querySelectorAll('[data-story-copy]');
    var words = story.querySelectorAll('[data-story-word]');
    var jumps = story.querySelectorAll('[data-story-jump]');
    var current = story.querySelector('[data-story-current]');

    [media, copies, words, jumps].forEach(function (group) {
      Array.prototype.forEach.call(group, function (element, index) {
        element.classList.toggle('is-active', index === activeIndex);
        if (group === media) {
          element.style.setProperty('--chapter-distance', clamp((progress * media.length) - index, -1, 1));
        }
      });
    });

    story.style.setProperty('--story-progress', progress);
    story.dataset.activeScene = String(activeIndex);
    if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
  }

  function updateMotion() {
    var scrollY = window.scrollY || window.pageYOffset;
    if (header) header.classList.toggle('is-scrolled', scrollY > 42);

    if (hero && !reducedMotion) {
      var heroRect = hero.getBoundingClientRect();
      var heroProgress = clamp(-heroRect.top / Math.max(heroRect.height, 1), 0, 1);
      hero.style.setProperty('--hero-progress', heroProgress);
    }

    stories.forEach(function (story) {
      var rect = story.getBoundingClientRect();
      var distance = Math.max(story.offsetHeight - window.innerHeight, 1);
      var progress = clamp(-rect.top / distance, 0, 1);
      var count = story.querySelectorAll('[data-story-media]').length;
      if (!count) return;
      var active = Math.min(count - 1, Math.floor(progress * count));
      setStoryScene(story, active, progress);
    });

    ticking = false;
  }

  function requestMotionUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateMotion);
  }

  stories.forEach(function (story) {
    story.querySelectorAll('[data-story-jump]').forEach(function (button) {
      button.addEventListener('click', function () {
        var count = story.querySelectorAll('[data-story-jump]').length;
        var index = Number(button.dataset.storyJump);
        var distance = Math.max(story.offsetHeight - window.innerHeight, 1);
        var storyTop = story.getBoundingClientRect().top + window.scrollY;
        var targetProgress = count > 1 ? index / (count - 0.35) : 0;
        window.scrollTo({ top: storyTop + (distance * targetProgress), behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    });
  });

  var revealTargets = document.querySelectorAll(
    '.section-heading, .aevex-standard__intro, .aevex-standard__checks li, .ownership__intro, .ownership-calculator, .global-locale, .global-card, .featured-products__header, .product-card, .robot-concierge__intro, .robot-concierge__panel, .trust-item, .newsletter__content, .collection-editorial__header, .collection-editorial__standard, .collection-editorial__guidance, .trust-banner, .trust-payments, .aevex-hero__stats, .aevex-hero__social-proof, .home-categories__card, .featured-deal, .email-capture, .testimonials__card, .usp-card, .brand-story, .home-cta-banner, .brand-logos__item'
  );

  if ('IntersectionObserver' in window && !reducedMotion) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    revealTargets.forEach(function (target, index) {
      target.classList.add('motion-reveal');
      target.style.setProperty('--reveal-delay', (index % 4) * 55 + 'ms');
      revealObserver.observe(target);
    });
  } else {
    revealTargets.forEach(function (target) { target.classList.add('is-revealed'); });
  }

  if (!reducedMotion && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.global-card, .product-card, .ownership-calculator, .robot-concierge__panel').forEach(function (card) {
      card.classList.add('motion-tilt');
      card.addEventListener('pointermove', function (event) {
        var bounds = card.getBoundingClientRect();
        var x = (event.clientX - bounds.left) / bounds.width - 0.5;
        var y = (event.clientY - bounds.top) / bounds.height - 0.5;
        card.style.setProperty('--tilt-x', (-y * 2.5).toFixed(2) + 'deg');
        card.style.setProperty('--tilt-y', (x * 3.5).toFixed(2) + 'deg');
        card.style.setProperty('--glow-x', ((x + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--glow-y', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  function getCartShell() {
    return document.querySelector('[data-cart-shell]');
  }

  function openCart() {
    var shell = getCartShell();
    if (!shell) return;
    shell.classList.add('is-open');
    var drawer = shell.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    var closeButton = shell.querySelector('[data-cart-close]');
    if (closeButton) window.setTimeout(function () { closeButton.focus(); }, 120);
  }

  function closeCart() {
    var shell = getCartShell();
    if (!shell) return;
    shell.classList.remove('is-open');
    var drawer = shell.querySelector('[data-cart-drawer]');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-open]').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
      var count = link.querySelector('.site-header__cart-count');
      if (cart.item_count > 0 && !count) {
        count = document.createElement('span');
        count.className = 'site-header__cart-count';
        link.appendChild(count);
      }
      if (count) {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      }
    });
  }

  function refreshCart(openAfter) {
    return Promise.all([
      fetch(window.Shopify.routes.root + '?sections=cart-drawer').then(function (response) { return response.json(); }),
      fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); })
    ]).then(function (responses) {
      var sectionContainer = document.getElementById('shopify-section-cart-drawer');
      if (sectionContainer && responses[0]['cart-drawer']) sectionContainer.innerHTML = responses[0]['cart-drawer'];
      updateCartCount(responses[1]);
      if (openAfter) openCart();
    });
  }

  document.addEventListener('click', function (event) {
    var cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen && !event.metaKey && !event.ctrlKey) {
      event.preventDefault();
      openCart();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }

    var changeButton = event.target.closest('[data-cart-change]');
    if (!changeButton) return;
    event.preventDefault();
    changeButton.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: changeButton.dataset.key, quantity: Number(changeButton.dataset.quantity) })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not update your selection.');
      return refreshCart(true);
    }).catch(function (error) {
      changeButton.disabled = false;
      window.alert(error.message);
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('.shopify-payment-button')) return;
    event.preventDefault();
    var submitButton = event.submitter || form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.dataset.originalLabel = submitButton.textContent;
      submitButton.textContent = 'Adding to your order…';
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || 'This selection could not be added.');
        return refreshCart(true);
      });
    }).catch(function (error) {
      window.alert(error.message);
    }).finally(function () {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = submitButton.dataset.originalLabel;
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && getCartShell() && getCartShell().classList.contains('is-open')) closeCart();
  });

  window.addEventListener('scroll', requestMotionUpdate, { passive: true });
  window.addEventListener('resize', requestMotionUpdate);
  window.addEventListener('load', requestMotionUpdate);
  requestMotionUpdate();
  window.requestAnimationFrame(function () { document.body.classList.add('motion-ready'); });
})();
